"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTokenAccount = void 0;
const tslib_1 = require("tslib");
const solana_contrib_1 = require("@saberhq/solana-contrib");
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const layout_1 = require("../layout");
const createTokenAccount = ({ provider, mint, owner = provider.wallet.publicKey, payer = provider.wallet.publicKey, accountSigner = web3_js_1.Keypair.generate(), }) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
    // Allocate memory for the account
    const balanceNeeded = yield spl_token_1.Token.getMinBalanceRentForExemptAccount(provider.connection);
    const tokenAccount = accountSigner.publicKey;
    return {
        key: tokenAccount,
        tx: new solana_contrib_1.TransactionEnvelope(provider, [
            web3_js_1.SystemProgram.createAccount({
                fromPubkey: payer,
                newAccountPubkey: accountSigner.publicKey,
                lamports: balanceNeeded,
                space: layout_1.TokenAccountLayout.span,
                programId: spl_token_1.TOKEN_PROGRAM_ID,
            }),
            spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, mint, tokenAccount, owner),
        ], [accountSigner]),
    };
});
exports.createTokenAccount = createTokenAccount;
//# sourceMappingURL=account.js.map